import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { StatusStateEnum } from "~/types/enums";
import toastsActionCreators from "~/store/toasts/actions";
import { Button, Modal, Alert } from "~/components-shared";
import authSelectors from "~/store/auth/selectors";
import authActionCreators from "~/store/auth/actions";
import PasswordChangeForm from "~/forms/PasswordChangeForm";
import passwordChangeSchema from "~/forms/PasswordChangeForm/passwordChangeSchema";
import { usePostHog } from "posthog-js/react";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const ProfileChangePasswordModal = _ref => {
  let {
    onClose
  } = _ref;
  const {
    t
  } = useTranslation();
  const status = useSelector(authSelectors.getStatus);
  const error = useSelector(authSelectors.getError);
  const dispatch = useDispatch();
  const posthog = usePostHog();
  const defaultValues = {
    currentPassword: "",
    password: "",
    repeatPassword: ""
  };
  const {
    handleSubmit,
    control,
    watch,
    reset
  } = useForm({
    resolver: yupResolver(passwordChangeSchema),
    mode: "onChange",
    defaultValues
  });
  const onSubmit = handleSubmit(data => {
    dispatch(authActionCreators.changePasswordStarted(data, _ref2 => {
      let {
        data: newUser
      } = _ref2;
      if (newUser) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("ProfileChangePasswordModal.passwordChanged"),
          timeout: 10000
        }));
        onClose();
        reset(defaultValues);
      }
    }));
    posthog.capture(`Profile Password Change – Save`);
  });
  const handleCancel = () => {
    dispatch(authActionCreators.actionChanged(undefined));
    onClose();
    posthog.capture(`Profile Password Change – Cancel`);
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    onClose: onClose,
    title: t("ProfileChangePasswordModal.changePassword"),
    maxWidth: "420px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(PasswordChangeForm, {
    control: control,
    watch: watch
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleCancel,
    rounded: true,
    display: "inline-block"
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    display: "inline-block",
    maxWidth: "230px",
    type: "submit",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("common.actions.save")))));
};
export default ProfileChangePasswordModal;